import React from 'react';
import { connect } from 'react-redux';

const StandingsTable = ({ app, teams, week}) => {
  // sort standings by rank since I can't order with the firestore query
  teams.sort((a, b) => a.rank - b.rank);

  let totalgames = 0;
  for (let i = 0; i < teams.length; i++) {
    totalgames += teams[i].games.total;
  }
  const games = Math.ceil(totalgames / teams.length / 3);

  return (
    <div className="standings-table">
      <div className="standings-table--header">
        <div className="standings-table--header--rank col-rank">#</div>
        <div className="standings-table--header--team col-team">Team</div>
        <div className="standings-table--header--points col-points twdtd">
          D
        </div>
        <div className="standings-table--header--points col-points twdtj">
          J
        </div>
        <div className="standings-table--header--points col-points twdtb">
          B
        </div>
        <div className="standings-table--header--points col-points total">
          Total
        </div>
      </div>
      {teams.map((team, key) => {
        let classes = ['standings-table--row'];

        if (team.eliminated && week === 5) {
          classes.push('eliminated');
        }

        // if (key === 1 && week === 5) {
        //   classes.push('bye--line');
        // }

        if (key === 5 && week === 5) {
          classes.push('elimination--line');
        }

        return (
          <div key={key} className={classes.join(' ')}>
            <div className="standings-table--row--rank col-rank ">
              {team.rank}
              <div className={"col-rank-change" + (team.prevrank - team.rank > 0 ? ' col-rank-change-pos' : (team.prevrank - team.rank < 0 ? ' col-rank-change-neg' : ''))}>
                {(team.prevrank - team.rank !== 0 && week > 1 ? (team.prevrank - team.rank > 0 ? '+' : '') + (team.prevrank - team.rank) : '')}
              </div>
            </div>
            <div className="standings-table--row--team col-team">
              <div className="standings-table--row--team--image">
                <img src={team.imgUrl} alt={team.name} width="45" height="45" />
              </div>
              <div className="standings-table--row--team--name">
                {team.name}
              </div>
              <div className="standings-table--row--team--captains">
                {team.cap}
              </div>
            </div>
            <div className="standings-table--row--points col-points">
              {team.points.TWDTD}<span className="standings-table--row--games">{(team.games.TWDTD !== games ? ' (' + (games - team.games.TWDTD) + ')' : '')}</span>
              <div className={"col-rank-league" + (key < 6 && week === 5 && team.leaguerank.TWDTD < 3 ? ' col-rank-league-top2' : '')}>
                {(key < 6 && week === 5 ? suf(team.leaguerank.TWDTD) : '')}
              </div>
            </div>
            <div className="standings-table--row--points col-points">
              {team.points.TWDTJ}<span className="standings-table--row--games">{(team.games.TWDTJ !== games ? ' (' + (games - team.games.TWDTJ) + ')' : '')}</span>
              <div className={"col-rank-league" + (key < 6 && week === 5 && team.leaguerank.TWDTJ < 3 ? ' col-rank-league-top2' : '')}>
                {(key < 6 && week === 5 ? suf(team.leaguerank.TWDTJ) : '')}
              </div>
            </div>
            <div className="standings-table--row--points col-points">
              {team.points.TWDTB}<span className="standings-table--row--games">{(team.games.TWDTB !== games ? ' (' + (games - team.games.TWDTB) + ')' : '')}</span>
              <div className={"col-rank-league" + (key < 6 && week === 5 && team.leaguerank.TWDTB < 3 ? ' col-rank-league-top2' : '')}>
                {(key < 6 && week === 5 ? suf(team.leaguerank.TWDTB) : '')}
              </div>
            </div>
            <div className="standings-table--row--points col-points total">
            {team.points.total}
            {/* <span className="standings-table--row--games total">{(team.games.total !== games * 3 ? ' (' + (games * 3 - team.games.total) + ')' : '')}</span> */}
            </div>
          </div>
        );
      })}
      <span className="standings-table--legend">Number between brackets are games a team has yet to (re)play in that league.</span>
    </div>
  );
};

function suf(i) {
  var j = i % 10,
      k = i % 100;
  if (j === 1 && k !== 11) {
      return i + "st";
  }
  if (j === 2 && k !== 12) {
      return i + "nd";
  }
  if (j === 3 && k !== 13) {
      return i + "rd";
  }
  return i + "th";
}

const mapStateToProps = (state) => ({
  app: state.app,
});

export default connect(mapStateToProps)(StandingsTable);



// WEBPACK FOOTER //
// ./src/components/standings-table/standings-table.js